import useFeature from '@core/components/LaunchDarkly';

// needs updating when nova2 language support is expanded
const nova2Langs = [
  'en',
  'en-US',
  'en-AU',
  'en-GB',
  'en-NZ',
  'en-IN',
  'fr',
  'fr-FR',
  'fr-CA',
  'de',
  'hi',
  'hi-Latn',
  'pt',
  'es',
  'es-419',
  // the following added based on the language page
  'bg-BG',
  'ca-ES',
  'zh-CN',
  'zh-TW',
  'cs-CZ',
  'da-DK',
  'nl-NL',
  'et-EE',
  'fi-FI',
  'nl-BE',
  'de-DE',
  'de-CH',
  'el-GR',
  'hi-IN',
  'hu-HU',
  'id-ID',
  'it-IT',
  'ja-JP',
  'ko-KR',
  'lv-LV',
  'lt-LT',
  'ms-MY',
  'no-NO',
  'pl-PL',
  'pt-PT',
  'pt-BR',
  'ro-RO',
  'ru-RU',
  'sk-SK',
];

/** @type {(localeCode: string) => string} */
const useDeepgramEndpoint = (localeCode) => {
  const noEndpointingDeepgramFeature = useFeature('no-endpointing-deepgram');
  const params = new URLSearchParams();
  if (nova2Langs.includes(localeCode)) {
    params.set('model', 'nova-2');
  }
  params.set('language', localeCode);
  params.set('punctuate', 'true');
  params.set('interim_results', 'true');
  params.set('utterance_end_ms', '1250');

  if (!noEndpointingDeepgramFeature) {
    params.set('endpointing', '700');
  }

  const deepgramEndpoint = `wss://api.deepgram.com/v1/listen?${params.toString()}`;
  return deepgramEndpoint;
};

export default useDeepgramEndpoint;
